import { ApiError } from "../api/client";

/**
 * A failed list/detail query must never render as an empty result.
 *
 * The three paginated pages used to pass `items: []` / `total: 0` straight
 * through on error, so PaginatedTable's "Nothing in this range." was shown
 * for a 500 exactly as it was for a genuinely empty range -- which is how a
 * broken /portal/transactions endpoint looked like a customer with no
 * transactions. Callers render this instead of the table when `error` is set.
 */
export function QueryError({ error, what }: { error: Error; what: string }) {
  const status = error instanceof ApiError ? error.status : undefined;
  const detail =
    status === 400 ? "The request was rejected — check the date range."
    : status === 403 ? "You do not have access to this data."
    : status && status >= 500 ? "The server failed to answer. This is a bug, not an empty result."
    : "Something went wrong loading this data.";

  return (
    <div className="card query-error">
      <strong>Couldn't load {what}.</strong>
      <p>{detail}{status ? ` (HTTP ${status})` : ""}</p>
    </div>
  );
}
